/*
 * Copyright (c) 2024. Spin in het Web B.V. Apeldoorn NL.
 * Deze software is géén open source. Het auteursrecht van deze software
 * ligt bij Spin in het Web B.V. en/of Jellybean B.V. en/of de auteur.
 * Gebruik van deze software is onderhevig aan een licentieovereenkomst.
 * www.spininhetweb.nl
 */

/*
* types.ts
* 2-12-2019 - Jelmer Jellema - Spin in het Web B.V.
* Typedefinities
*/

// helpers
export interface hash<Type> {
  [key: string]: Type;
}


